const styles = theme => ({
  root: {
    backgroundColor: "#EFF6EE",
    "@supports (padding-top: constant(safe-area-inset-top))": {
      "--safe-area-inset-top": "constant(safe-area-inset-top)",
      paddingTop: "var(--safe-area-inset-top)"
    },
    "@supports (padding-top: env(safe-area-inset-top))": {
      "--safe-area-inset-top": "env(safe-area-inset-top)",
      paddingTop: "var(--safe-area-inset-top)"
    }
  },
  logoContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    height: 34,
    width: 34
  },
  // organizationLogo: {
  //   borderRadius: 100,
  //   height: 34,
  //   width: 34
  // },
  // CSS for the avatar, name and rol

  // userContainer: {
  //   display: "flex"
  // },
  // textContainer: {
  //   paddingRight: 10,
  //   textAlignLast: "center",
  //   margin: "auto",
  //   [theme.breakpoints.down("sm")]: {
  //     display: "none"
  //   }
  // },
  // user: {
  //   fontSize: 20,
  //   letterSpacing: 0,
  //   fontFamily: "'Poppins', 'sans-serif'",
  //   textAlign: "right",
  //   height: 26
  // },
  // role: {
  //   color: theme.palette.primary.default,
  //   fontSize: 12,
  //   fontFamily: "Roboto",
  //   letterSpacing: 0,
  //   fontWeight: 400,
  //   height: 14
  // },

  // avatar: {
  //   margin: "auto",
  //   width: 50,
  //   height: 50
  // },
  menuTitle: {
    marginBottom: theme.spacing(2)
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/components/AdminHeader/styles.js